import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getPopupFeatures } from '@toruslabs/customauth';
import { SecurePubSub } from '@toruslabs/secure-pub-sub';
import { EventEmitter } from 'events';
import { LoginError } from './errors.js';

class PopupHandler extends EventEmitter {
  constructor({
    url,
    target,
    features,
    timeout = 30000,
    socketUrl,
    serverUrl
  }) {
    // Disabling the rule here, as it is a false positive.

    super();
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "features", void 0);
    _defineProperty(this, "window", void 0);
    _defineProperty(this, "windowTimer", void 0);
    _defineProperty(this, "iClosedWindow", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "socketUrl", void 0);
    _defineProperty(this, "serverUrl", void 0);
    _defineProperty(this, "securePubSub", null);
    this.url = url;
    this.target = target || "_blank";
    this.features = features || getPopupFeatures();
    this.window = undefined;
    this.windowTimer = undefined;
    this.iClosedWindow = false;
    this.timeout = timeout;
    this.serverUrl = serverUrl;
    this.socketUrl = socketUrl;
    this._setupTimer();
  }
  _setupTimer() {
    this.windowTimer = Number(setInterval(() => {
      if (this.window && this.window.closed) {
        clearInterval(this.windowTimer);
        setTimeout(() => {
          if (!this.iClosedWindow) {
            this.emit("close");
          }
          this.iClosedWindow = false;
          this.window = undefined;
          if (this.securePubSub) {
            this.securePubSub.cleanup();
            this.securePubSub = null;
          }
        }, this.timeout);
      }
      if (this.window === undefined) clearInterval(this.windowTimer);
    }, 500));
  }
  open() {
    var _this$window;
    this.window = window.open(this.url, this.target, this.features);
    if (!this.window) throw LoginError.popupBlocked();
    if ((_this$window = this.window) !== null && _this$window !== void 0 && _this$window.focus) this.window.focus();
  }
  close() {
    this.iClosedWindow = true;
    if (this.window) this.window.close();
    if (this.securePubSub) {
      this.securePubSub.cleanup();
      this.securePubSub = null;
    }
  }
  redirect(locationReplaceOnRedirect) {
    if (locationReplaceOnRedirect) {
      window.location.replace(this.url);
    } else {
      window.location.href = this.url;
    }
  }
  async listenOnChannel(loginId) {
    this.securePubSub = new SecurePubSub({
      serverUrl: this.serverUrl,
      socketUrl: this.socketUrl,
      sameIpCheck: true,
      allowedOrigin: true
    });
    const data = await this.securePubSub.subscribe(loginId);
    this.close();
    const parsedData = JSON.parse(data);
    if (parsedData.error) {
      return {
        error: parsedData.error,
        state: parsedData.state
      };
    }
    return parsedData.data;
  }
}

export { PopupHandler as default };
